import leftPad from "left-pad";
import React from "react";
import { formataNumeroApostaSeparador } from "src/loteria/utils/apostaUtils";
import { convertIntegerToMoney } from "src/modules/helpers";

function CarrinhoItem({ aposta, apagaAposta }) {
  return (
    <li
      className="list-group-item itemCarrinho"
      id={aposta.Aposta_ID}
      key={aposta.Aposta_ID}
    >
      <div className="carrinho_row row" style={{ display: "inline-block" }}>
        <div
          className="col-md-2 col-sm-2 col-xs-2"
          style={{ paddingLeft: "13px" }}
        >
          <div className="smallCircle">
            <p>{leftPad(aposta.Aposta_ID, 2, 0)}</p>
          </div>
        </div>
        <div className="col-md-9 col-sm-8 col-xs-8">
          <div>
            <b>
              <span className="info">{`${
                aposta.tipo.vchNome
              } a R$ ${convertIntegerToMoney(aposta.valor)}`}</span>
            </b>
          </div>
          <div>
            <span className="info subInfo">
              Prêmio: {aposta.strPremiosVisualizacao}
            </span>
          </div>
          <div className="divCarrinho">
            {aposta.numeros.map((num) => (
              <span className="default-button">
                {formataNumeroApostaSeparador(num, aposta.tipo)}
              </span>
            ))}
          </div>
        </div>
        <div
          className="col-md-1 col-sm-2 col-xs-2"
          style={{ top: "12px", fontSize: "20px" }}
        >
          <a
            href="javascript:;"
            className="removeItemCarrinho"
            onClick={() => apagaAposta(aposta.Aposta_ID, aposta.valorTotal)}
          >
            <i className="glyphicon glyphicon-remove-sign"></i>
          </a>
        </div>
      </div>
      <div className="itemFooter">
        <b>
          <span className="info">{`Subtotal: R$ ${convertIntegerToMoney(
            aposta.valorTotal
          )}`}</span>
        </b>
      </div>
    </li>
  );
}

export default CarrinhoItem;



// WEBPACK FOOTER //
// ./src/carrinho/carrinho-item.jsx